/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Replace_LabelInputs */

const en_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

const fr_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer`)
};

const de_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen`)
};

const it_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituire`)
};

const ru_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заменять`)
};

const es_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar`)
};

const zh_cn2_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代替`)
};

const ja_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換する`)
};

const hi_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिस्थापित करें`)
};

const pt_pt2_marker_import_replace_label = /** @type {(inputs: Marker_Import_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir`)
};

/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Marker_Import_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_replace_label = /** @type {((inputs?: Marker_Import_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_replace_label(inputs)
	if (locale === "de") return de_marker_import_replace_label(inputs)
	if (locale === "it") return it_marker_import_replace_label(inputs)
	if (locale === "ru") return ru_marker_import_replace_label(inputs)
	if (locale === "es") return es_marker_import_replace_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_replace_label(inputs)
	if (locale === "ja") return ja_marker_import_replace_label(inputs)
	if (locale === "hi") return hi_marker_import_replace_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_replace_label(inputs)
	return en_marker_import_replace_label(inputs)
});